// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart[data-v-6454f3e6] {\n    min-height: 250px;\n    max-height: 250px;\n}\n", ""]);
// Exports
module.exports = exports;
